<template>
  <div class="section histroy-section" v-if="coffeeGold.history.length">
    <div class="histroy-header">
      <div class="money-title">历史咖啡金</div>
      <div class="tips" v-show="!isShow" @click="showInfo(true)">
        展开明细
        <span class="icon down-icon"></span>
      </div>
      <div class="tips" v-show="isShow" @click="showInfo(false)">
        收起明细
        <span class="icon up-icon"></span>
      </div>
    </div>
    <div class="auto-container">
      <div class="month-money-list-item">
        <div
          :class="{ active: !$store.state.user.is_feedback }"
          class="text-view"
        >
          <span class="time">{{ coffeeGold.history[0].month }}咖啡金</span>
          <span class="dash">{{ coffeeGold.history[0].cost }}</span>
        </div>
      </div>
      <div class="detail-container" v-show="isShow">
        <div class="row header">
          <span class="time">订单时间</span>
          <span class="price">价格</span>
        </div>
        <div class="row" v-for="(item, index) in detailGold" :key="index">
          <span class="time">{{ formatTime(item.date) }} {{ item.week }} </span>
          <span class="price">{{ item.cost }}</span>
        </div>
      </div>
      <div
        v-for="(item, index) in coffeeGold.history"
        :key="index"
        class="month-money-list-item"
        v-show="index !== 0"
      >
        <div class="text-view">
          <span class="time">{{ item.month }}咖啡金</span>
          <span class="dash">{{ item.cost }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detailGold: {
      type: Array,
      default: null,
    },
    coffeeGold: {
      type: Object,
      default: () => {
        return { history: [] };
      },
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    formatTime(time) {
      return time.replace(/^.{5}/, "").split("-").join("/");
    },
    showInfo(status) {
      this.isShow = status;
    },
  },
};
</script>


<style lang="less" scoped>
.money-container {
  width: 900px;
  display: flex;
  flex-direction: column;
  position: relative;
  .money-title {
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
  }
  .break-line {
    width: 100%;
    margin-top: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  .money-view {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    &.money-now-month {
      justify-content: space-between;
      .left {
        display: flex;
      }
    }
    .title {
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ff9a28;
      border-radius: 15px;
      font-size: 16px;
      color: #ffffff;
    }
    .break-row {
      width: 1px;
      height: 34px;
      margin-left: 30px;
      margin-right: 30px;
      background-color: #e0e0e0;
    }
    .money {
      font-size: 24px;
      color: #333333;
    }
    .arrow-icon {
      width: 6px;
      height: 10px;
      background-image: url("../../../static/img/user/icon_next.png");
    }
  }
  .month-money-list-item {
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-top: 20px;
    .text-view {
      width: 900px;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f5f5f5;
      border-radius: 6px;
      color: #999;
      &.active {
        color: #fff;
        background: #ff9a28;
      }
      .time {
        font-size: 20px;
        margin-left: 24px;
      }
      .dash {
        font-size: 24px;
        margin-right: 20px;
      }
    }
  }
  .btn-group {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 960px;
    height: 82px;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-bottom: none;
    box-sizing: border-box;
    padding: 0 30px;
    .tips {
    }
    .btn-group-area {
      display: flex;
      justify-content: space-between;
      width: 282px;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 126px;
        height: 42px;
        border-radius: 21px;
      }
      .error-btn {
        border: 1px solid #ff9a28;
        color: #ff9a28;
        cursor: pointer;
      }
      .confirm-btn {
        background: #ff9a28;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .line {
    position: absolute;
    left: -30px;
    top: 274px;
    width: 960px;
    background: #f5f5f5;
    height: 10px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    box-sizing: border-box;
  }
  .section {
    box-sizing: border-box;
    &:nth-child(1) {
      margin-bottom: 10px;
    }
    .histroy-header {
      display: flex;
      height: 70px;
      line-height: 22px;
      border-bottom: 1px solid #e0e0e0;
      justify-content: space-between;
      .tips {
        display: flex;
        align-items: center;
        color: #ff9a28;
        font-size: 16px;
        cursor: pointer;
        .icon {
          width: 14px;
          height: 8px;
          margin-left: 5px;
        }
        .down-icon {
          background-image: url("../../../static/img/user/icon_down.png");
        }
        .up-icon {
          background-image: url("../../../static/img/user/icon_up.png");
        }
      }
    }
  }
  .detail-container {
    .row {
      display: flex;
      color: #666;
      font-size: 16px;
      border-bottom: 1px solid #e0e0e0;
      justify-content: space-between;
      height: 51px;
      align-items: center;
      .time {
        display: flex;
        align-items: center;
        width: 198px;
        margin-left: 10px;
        i {
          display: inline-block;
          position: relative;
          margin-left: 9px;
          width: 18px;
          height: 18px;
          background-image: url("../../../static/img/user/icon_notice.png");
          .rect {
            position: absolute;
            top: 20px;
            left: 4px;
            width: 0;
            height: 0;
            // border-left: 5px solid transparent;
            // border-right: 5px solid transparent;
            // border-bottom: 8px solid #e9e9e9;
            .notice-container {
              position: absolute;
              top: 8px;
              left: -50px;
              background: #fff;
              min-width: 400px;
              border-radius: 5px;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              color: #333;
              font-size: 14px;
              line-height: 17px;
              p {
                margin-left: 16px;
                font-style: normal;
              }
            }
          }
        }
      }
      .price {
        width: 52px;
        margin-right: 10px;
      }
    }
    .header {
      height: 32px;
      color: #999;
      margin-top: 16px;
    }
  }
  .histroy-section {
    height: calc(100% - 290px);
  }
  .auto-container {
    overflow-y: scroll;
    max-width: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/CoffeeGold.vue